import { css } from 'styled-components'

export default css`
  display: flex;
  flex: 1;
  min-height: 0;
  width: 100%;

  &.preview-root--document {
    overflow: hidden;
  }

  &.preview-root--image {
    overflow-y: auto;
  }

  .preview-document,
  .preview-image {
    display: block;
    width: 100%;
    border: 0;
  }

  .preview-document {
    flex: 1;
    min-height: 0;
    height: 100%;
  }

  .preview-image {
    height: auto;
  }
`
